import Component from './Component';

export default class Navigation extends Component {
	get events() {
		return {
			'click .navigation-toggle': 'handleToggle',
		};
	}

	handleToggle(e) {
		e.preventDefault();
		document.body.classList.toggle('has-navigation');
		this.el.classList.toggle('is-active');
	}
}
